import * as React from "react";

import I18n from "lib/I18n";
import { Graph } from "../Graph";

import { Stat } from "../../store";
import moment from "moment";

interface SeriesProps {
  stats: Stat[];
  daySelected: (day: number) => void;
}

export function Series(props: SeriesProps) {
  const { stats, daySelected } = props;

  const graphItemClicked = (e: unknown) => {
    if (typeof e != "object") {
      return;
    }
    if (!e) {
      return;
    }
    if (!("index" in e)) {
      return;
    }
    const index = e.index;
    if (typeof index === "number") {
      daySelected(index + 1);
    }
  };

  const prepareChartData = () => {
    const chartData: { [index: string]: number } = {};
    for (let i = 0; i < moment().daysInMonth(); i += 1) {
      chartData[i + 1] = 0;
    }
    stats.forEach((stat) => {
      const date = moment(stat.date);
      const dateStr = date.date();
      chartData[dateStr] += stat.cost;
    });
    return Object.keys(chartData)
      .map((key) => ({ date: parseInt(key, 10), sum: chartData[key] }))
      .sort((c1, c2) => {
        return c1.date - c2.date;
      });
  };

  const prepareConfig = () => {
    const chartData = prepareChartData();
    return {
      pathToImages: "/assets/amcharts/",
      type: "serial",
      theme: "light",
      categoryField: "date",
      startDuration: 1,
      categoryAxis: {
        gridPosition: "start",
        position: "left",
        title: I18n.t("bigquery_query_jobs_stats_viewer.label.day"),
      },
      graphs: [
        {
          id: "AmGraph-1",
          fillAlphas: 0.85,
          type: "column",
          valueField: "sum",
        },
      ],
      valueAxes: [
        {
          id: "ValueAxis-1",
          position: "left",
          title: I18n.t("bigquery_query_jobs_stats_viewer.label.cost"),
          axisAlpha: 0,
        },
      ],
      chartCursor: {
        cursorColor: "#258cbb",
        valueBalloonsEnabled: false,
        cursorAlpha: 0,
        valueLineAlpha: 0.5,
        valueLineBalloonEnabled: true,
        valueLineEnabled: true,
        zoomable: false,
        valueZoomable: false,
      },
      dataProvider: chartData,
      listeners: [
        {
          event: "clickGraphItem",
          method: graphItemClicked,
        },
      ],
    };
  };

  return (
    <div>
      <Graph
        id="bigquery-query-jobs-stats-viewer-series"
        config={prepareConfig()}
      />
    </div>
  );
}
